// extracted by mini-css-extract-plugin
export default {"IpWithPort":"IpWithPort_IpWithPort__FV-Hi","Wider":"IpWithPort_Wider__blx1l"};